import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AccountSecuritySection from "../components/AccountSecuritySection";

export default function AccountSecurityPage({
  role,
  theme = "pink",
  storageKey,
  loginPath = "/login",
}) {
  const navigate = useNavigate();
  const accountId = Number(localStorage.getItem(storageKey));

  useEffect(() => {
    if (!accountId) {
      navigate(loginPath);
    }
  }, [accountId, loginPath, navigate]);

  if (!accountId) {
    return null;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">账号安全</h1>
      <p className="text-sm text-gray-500 mb-6">
        绑定邮箱、修改密码。忘记密码时，验证码将发送到您绑定的邮箱。
      </p>
      <AccountSecuritySection
        role={role}
        accountId={accountId}
        theme={theme}
        standalone
      />
    </div>
  );
}
